import { AdministrationListMessage } from './types-store';

export const ACTION = {
  REQUEST_MESSAGES: 'MESSAGES_ADMINISTRATION_LIST:REQUEST_MESSAGES',
  RECEIVE_MESSAGES: 'MESSAGES_ADMINISTRATION_LIST:RECEIVE_MESSAGES',
  FAIL_MESSAGES: 'MESSAGES_ADMINISTRATION_LIST:FAIL_MESSAGES',

  REQUEST_UPDATE_MESSAGE: 'MESSAGES_ADMINISTRATION_LIST:REQUEST_UPDATE_MESSAGE',
  RECEIVE_UPDATE_MESSAGE: 'MESSAGES_ADMINISTRATION_LIST:RECEIVE_UPDATE_MESSAGE',
  FAIL_UPDATE_MESSAGE: 'MESSAGES_ADMINISTRATION_LIST:FAIL_UPDATE_MESSAGE',

  RECEIVE_DELETE_MESSAGE: 'MESSAGES_ADMINISTRATION_LIST:RECEIVE_DELETE_MESSAGE',

  UPDATE_QUERY: 'MESSAGES_ADMINISTRATION_LIST:UPDATE_QUERY',
  UPDATE_INCLUDE_INACTIVE: 'MESSAGES_ADMINISTRATION_LIST:UPDATE_INCLUDE_INACTIVE'
};

export class RequestMessages {
  public type: string = ACTION.REQUEST_MESSAGES;
  constructor(public clearList: boolean) { }
}

export class ReceiveMessages {
  public type: string = ACTION.RECEIVE_MESSAGES;
  constructor(
    public messages: AdministrationListMessage[],
    public numberOfResults: number,
    public clearList: boolean
  ) { }
}

export class FailMessages {
  public type: string = ACTION.FAIL_MESSAGES;
}

export class RequestUpdateMessage {
  public type: string = ACTION.REQUEST_UPDATE_MESSAGE;
  constructor(public id: number) { }
}

export class ReceiveUpdateMessage {
  public type: string = ACTION.RECEIVE_UPDATE_MESSAGE;
  constructor(
    public id: number,
    public includeInactive: boolean,
    public message: AdministrationListMessage
  ) { }
}

export class FailUpdateMessage {
  public type: string = ACTION.FAIL_UPDATE_MESSAGE;
  constructor(public id: number) { }
}

export class ReceiveDeleteMessage {
  public type: string = ACTION.RECEIVE_DELETE_MESSAGE;
  constructor(public id: number) { }
}

export class UpdateQuery {
  public type: string = ACTION.UPDATE_QUERY;
  constructor(public query: string) { }
}

export class UpdateIncludeInactive {
  public type: string = ACTION.UPDATE_INCLUDE_INACTIVE;
  constructor(public includeInactive: boolean) { }
}
